<template>
  <div>
    <div>
      <div>
        <div class="row my-4 mx-1 justify-content-center">
          <v-container v-if="progress" type="image" class="loding">
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </v-container>
          <div v-else class="col-lg-8 col-sm-12 col-md-10 borderPointier">
            <div class="background-white">
              <div class="title">
                <div class="position">
                  {{ $t("conditions_technique") }} 
                </div>
              </div>
            </div>
            <form @submit.prevent="isolation_mursAdd" class="my-3">
             <b-form-group
  label-for="select-type-appareil"
>
  <template #label>{{ $t('Types_isolants_thermiques') }}
    <span class="text-danger">*</span> 
  </template>
                <b-form-select
                  v-model="type_isolant"
                  :options="typeAppareilOptions"
                  id="select-type-appareil"
                  class="custom-input"
                >
                </b-form-select>
              </b-form-group>

              <div class="fieldset mb-2" v-if="type_isolant">
                <div class="legend mb-2">
                  {{ type_isolant === 'reflechesson_et_non_reflichessant' ? 'norme reflichessant' : $t('NORM') }} <span class="text-danger">*</span>
                </div>
                <b-form-input
                  type="text"
                  v-model="norme"
                  id="select-norme"
                  :placeholder="type_isolant === 'reflechesson_et_non_reflichessant' ? 'norme reflichessant' : $t('NORM')"
                  class="form-input custom-placeholder custom-input"
                >
                </b-form-input>
              </div>
              <div class="fieldset mb-2" v-if="type_isolant === 'reflechesson_et_non_reflichessant'">
                <div class="legend mb-2">norme non reflichessant <span class="text-danger">*</span></div>
                <b-form-input v-model="norme2" id="select-norme2" placeholder="norme non reflichessant" class="form-input custom-placeholder custom-input"></b-form-input>
              </div>
              <div class="fieldset mb-2">
                <div class="legend mb-2">
                  {{ $t("surface_isolant") }}  <span class="text-danger">*</span> 
                </div>
                <b-form-input
                  type="number"
                  @paste="
                    (event) =>
                      onPaste(event, 'isolation_mursData.Surface_isolant')
                  "
                  @keydown="(event) => onKeyDown(event)"
                  min="0"
                  v-model="isolation_mursData.Surface_isolant"
                  :placeholder="$t('surface_isolant')"
                  class="form-input custom-placeholder custom-input"
                >
                </b-form-input>
              </div>
              <div class="fieldset mb-2">
                <div class="legend mb-2">
                  {{ $t("resistance_thermique") }}   <span class="text-danger">*</span> 
                </div>
                <b-form-input
                  type="number"
                  min="0"
                  @paste="
                    (event) =>
                      onPaste(event, 'isolation_mursData.resistance_thermique')
                  "
                  @keydown="(event) => onKeyDown(event)"
                  v-model="isolation_mursData.resistance_thermique"
                  :placeholder="$t('resistance_thermique')"
                  class="form-input custom-placeholder custom-input"
                >
                </b-form-input>
              </div>
              <div class="fieldset mb-2">
                <div class="legend mb-2">
                  {{ $t("epaisseur") }}   <span class="text-danger">*</span> 
                </div>
                <b-form-input
                  type="number"
                  @paste="
                    (event) => onPaste(event, 'isolation_mursData.epaisseur')
                  "
                  @keydown="(event) => onKeyDown(event)"
                  min="0"
                  v-model="isolation_mursData.epaisseur"
                  :placeholder="$t('epaisseur')"
                  class="form-input custom-placeholder custom-input"
                >
                </b-form-input>
              </div>
              
              <!-- Champs contact sur site -->
              <div class="fieldset mb-2">
                <div class="legend mb-2">
                  {{ $t("Contact sur site") || "Contact sur site" }}
                </div>
                <b-form-input
                  type="text"
                  v-model="contactSurSite"
                  :placeholder="$t('Contact sur site') || 'Contact sur site'"
                  class="form-input custom-placeholder custom-input"
                  @input="updateContactSurSite"
                />
              </div>
              
              <div class="fieldset mb-2">
                <div class="legend mb-2">
                  {{ $t("Fonction") || "Fonction" }}
                </div>
                <b-form-input
                  type="text"
                  v-model="fonctionContact"
                  :placeholder="$t('Fonction') || 'Fonction'"
                  class="form-input custom-placeholder custom-input"
                  @input="updateFonctionContact"
                />
              </div>
              
              <div class="fieldset mb-2">
                <div class="legend mb-2">
                  {{ $t("Téléphone") || "Téléphone" }}
                </div>
                <phone
                  :tel="telephoneContact"
                  @phoneNumber="formatTelephoneContact($event)"
                ></phone>
              </div>
            </form>
       
          </div>
        </div>
     
      </div>
  
      <!-- <div v-if="show" class="d-flex justify-content-end mt-4">
            <b-button v-if="this.visibleTabsLength<=1" @click="goToPrevStep" class="button-pre-style m-3">
        {{ $t("PREVIOUS") }}
      </b-button>
      <b-button
        type="submit"
        @click="goToStep"
        class="button-suivant-style m-3"
      >
        <template v-if="isLoading">
          <div class="loading ml-2">
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
        </template>
    
        <template v-else>
          {{ buttonText }}
        </template>
      </b-button>
    </div> -->
      <div v-if="!show" class="d-flex justify-content-end mt-4">
        <b-button @click="goToPrevStep" class="button-pre-style m-3">
          {{ $t("PREVIOUS") }}
        </b-button>
        <b-button
          type="submit"
          @click="goToStep"
          class="button-suivant-style m-3"
        >
          {{ $t("NEXT") }}
          <div class="loading ml-2" v-if="isLoading">
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
          <div class="loading ml-2" v-if="isLoadingButton">
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
        </b-button>
        <Snackbar ref="snackbar" class="mt-5" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import domain from "@/environment";
import axios from "axios";
import Snackbar from "@/components/ui/errorSnackbar.vue";
import phone from "@/components/ui/phone.vue";
import { handlePaste, preventExceedingLengthFloat } from "@/utils/inputUtils";
export default {
  components: {
    Snackbar,
    phone,
  },
  props: {
    title: {
      type: String,
      default: "",
      required: false,
    },
    visibleTabsLength: {
      type: Number,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
      
    },
    isLoadingButton: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCompleted: false,
      isLoading: false,
      isolation_mursData: null,
      isolation_murs: false,
      type_isolant: null,
      norme: null,
      norme2: null,
      errorMessage: "",
      contactSurSite: null,
      fonctionContact: null,
      telephoneContact: null,
      typeAppareilOptions: [
        { value: null, text: this.$t("Sélectionnez_type"), disabled: true },
        { value: "non reflechissant", text: this.$t("non_reflechissant") },
        { value: "reflechissant", text: this.$t("reflechissant") },
        { value: "reflechesson_et_non_reflichessant", text: this.$t("reflechesson et non reflichessant") }, // option combinée
      ],
    };
  },
  created() {
    if (this.getdevisMonoFiche && this.getdevisMonoFiche.data) {
      this.isolation_mursData = this.initializeisolation_murs();
      this.initializeContactFields();
    }
  },
  computed: {
    ...mapState({
      token: (state) => state.token,
    }),
    ...mapGetters(["getdevisMonoFiche"]),
    buttonText() {
      return this.visibleTabsLength <= 1 ? this.$t("NEXT") : this.$t("CONFIRMER");
    },
  },

  watch: {
    getdevisMonoFiche: {
      handler(newDevis) {
        if (newDevis && newDevis.data) {
          // Préserver les valeurs locales existantes
          const currentSurface = this.isolation_mursData?.Surface_isolant;
          const currentEpaisseur = this.isolation_mursData?.epaisseur;
          const currentResistance = this.isolation_mursData?.resistance_thermique;
          const currentTypeIsolant = this.type_isolant;
          const currentNorme = this.norme;
          const currentNorme2 = this.norme2;
          
          this.isolation_mursData = this.initializeisolation_murs();
          
          // Restaurer les valeurs locales si elles existent
          if (currentSurface !== undefined && currentSurface !== "") {
            this.isolation_mursData.Surface_isolant = currentSurface;
          }
          if (currentEpaisseur !== undefined && currentEpaisseur !== "") {
            this.isolation_mursData.epaisseur = currentEpaisseur;
          }
          if (currentResistance !== undefined && currentResistance !== "") {
            this.isolation_mursData.resistance_thermique = currentResistance;
          }
          if (currentTypeIsolant !== null && currentTypeIsolant !== undefined) {
            this.type_isolant = currentTypeIsolant;
          }
          if (currentNorme !== null && currentNorme !== undefined) {
            this.norme = currentNorme;
          }
          if (currentNorme2 !== null && currentNorme2 !== undefined) {
            this.norme2 = currentNorme2;
          }
          
          this.isolation_murs = newDevis.data?.devis.isolation_murs !== null;
          if (!this.type_isolant) {
          this.type_isolant =
            newDevis.data?.devis?.isolation_murs?.type_isolant || null;
          }
          if (!this.norme) {
          this.norme = newDevis.data?.devis?.isolation_murs?.norme || null;
          }
          if (!this.norme2) {
          this.norme2 = newDevis.data?.devis?.isolation_murs?.norme2 || null;
          }
          this.initializeContactFields();
          if (this.isolation_murs) {
            this.isCompleted = true;
          }
        }
      },
      deep: true,
      immediate: true,
    },
    type_isolant(newVal) {
      if (newVal !== 'reflechesson_et_non_reflichessant') {
        this.norme2 = null;
      }
    },
  },
  methods: {
    ...mapActions(["setDevisMonoFiche"]),

    onKeyDown(event) {
      preventExceedingLengthFloat(event);
    },

    onPaste(event, fieldName) {
      handlePaste.call(this, event, fieldName);
    },
    async postIsolationMur(payload) {
      try {
        const response = await axios.post(domain + `/isolation_murs`, payload, {
          headers: {
            Authorization: `Bearer ` + this.token,
          },
        });

        return response.data.data;
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.errorMessage = error.response.data.message;
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.errorMessage = error.response.data.errors.join(", ");
        } else {
          this.errorMessage = "Vérifiez vos données.";
        }

        this.$refs.snackbar.showSnackbar(this.errorMessage);

        return null;
      }
    },

    async putIsolationMur(payload) {
      try {
        const response = await axios.put(
          domain + `/isolation_murs/${payload.id}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ` + this.token,
            },
          }
        );

        return response.data.data;
      } catch (error) {
        throw new Error("Failed to post isolation combles toiture.");
      }
    },
    initializeisolation_murs() {
      const isolation_murs =
        this.getdevisMonoFiche?.data?.devis.isolation_murs || {};

      return {
        id: isolation_murs.id,
        resistance_thermique: isolation_murs.resistance_thermique || "",
        norme: isolation_murs.norme || "",
        norme2: isolation_murs.norme2 || "",
        epaisseur: isolation_murs.epaisseur || "",
        Surface_isolant: isolation_murs.Surface_isolant || "",
        type_isolant: isolation_murs.type_isolant || "",
      };
    },
    async isolationAdd() {

      this.isolation_mursData.type_isolant = this.type_isolant;
      this.isolation_mursData.norme = this.norme;
      this.isolation_mursData.norme2 = this.type_isolant === 'reflechesson_et_non_reflichessant' ? this.norme2 : null;
       if(!this.type_isolant ||!this.norme || !this.isolation_mursData.epaisseur|| !this.isolation_mursData.resistance_thermique){
       this.errorMessage = this.$t("Tous_obligatoires");
    this.$refs.snackbar.showSnackbar(this.errorMessage);
        return
      }
      
      // S'assurer que les valeurs numériques sont correctement formatées
      const payload = {
        ...this.isolation_mursData,
        Surface_isolant: this.isolation_mursData.Surface_isolant && this.isolation_mursData.Surface_isolant !== "" 
          ? parseFloat(this.isolation_mursData.Surface_isolant) 
          : null,
        epaisseur: this.isolation_mursData.epaisseur && this.isolation_mursData.epaisseur !== "" 
          ? parseFloat(this.isolation_mursData.epaisseur) 
          : null,
        resistance_thermique: this.isolation_mursData.resistance_thermique && this.isolation_mursData.resistance_thermique !== "" 
          ? parseFloat(this.isolation_mursData.resistance_thermique) 
          : null,
      };
      
      const response = await this.postIsolationMur(payload);

      if (response !== null) {
        this.getdevisMonoFiche.data.devis.isolation_murs_id = response.id;

        this.getdevisMonoFiche.data.devis.isolation_murs = {
          id: this.getdevisMonoFiche.data.devis.isolation_murs_id,
          Surface_isolant: this.isolation_mursData.Surface_isolant,
          epaisseur: this.isolation_mursData.epaisseur,
          resistance_thermique: this.isolation_mursData.resistance_thermique,
          norme: this.isolation_mursData.norme,
          norme2: this.isolation_mursData.norme2,
          type_isolant: this.isolation_mursData.type_isolant,
        };

        this.setDevisMonoFiche(this.getdevisMonoFiche);
        return response;
      } else {
        this.isLoading = false;

        return;
      }
    },

    async isolation_mursAdd() {
      if (this.isolation_murs) {
        this.isolation_mursData.type_isolant = this.type_isolant;
        this.isolation_mursData.norme = this.norme;
        this.isolation_mursData.norme2 = this.norme2;
        
        // S'assurer que les valeurs numériques sont correctement formatées
        const chauffe = {
          ...this.isolation_mursData,
          id: this.getdevisMonoFiche.data.devis.isolation_murs.id,
          Surface_isolant: this.isolation_mursData.Surface_isolant && this.isolation_mursData.Surface_isolant !== "" 
            ? parseFloat(this.isolation_mursData.Surface_isolant) 
            : null,
          epaisseur: this.isolation_mursData.epaisseur && this.isolation_mursData.epaisseur !== "" 
            ? parseFloat(this.isolation_mursData.epaisseur) 
            : null,
          resistance_thermique: this.isolation_mursData.resistance_thermique && this.isolation_mursData.resistance_thermique !== "" 
            ? parseFloat(this.isolation_mursData.resistance_thermique) 
            : null,
        };

        const reponse = await this.putIsolationMur(chauffe);
        this.getdevisMonoFiche.data.devis.isolation_murs = {
          id: this.getdevisMonoFiche.data.devis.isolation_murs.id,
          Surface_isolant: this.isolation_mursData.Surface_isolant,
          resistance_thermique: this.isolation_mursData.resistance_thermique,
          epaisseur: this.isolation_mursData.epaisseur,
          norme: this.isolation_mursData.norme,
          norme2: this.isolation_mursData.norme2,
          type_isolant: this.isolation_mursData.type_isolant,
        };

        this.setDevisMonoFiche(this.getdevisMonoFiche);
        return reponse;
      }
      await this.isolationAdd();
    },
    async goToStep() {
      this.isLoading = true;
      if (this.isolation_mursData.Surface_isolant == "") {
        this.isLoading = false;
        this.$refs.snackbar.showSnackbar("Tous_obligatoires");
      }
      if (this.type_isolant === "reflechesson_et_non_reflichessant" && !this.norme2) {
        this.isLoading = false;
        this.isCompleted = false;
        this.$refs.snackbar.showSnackbar(this.$t('NORM') + " 2 est obligatoire");
        return;
      }
      await this.isolation_mursAdd();
      if (this.errorMessage !== "") {
        this.isLoading = false;
        this.isCompleted = true;
        return;
      }
      this.isLoading = false;
      if(this.visibleTabsLength<=1){
        this.$emit("change",true);
      }else {
        this.$emit("change",false);
      }
    },
    async goToNextStep() {
      this.isLoading = true;
      if (this.isolation_mursData.Surface_isolant == "") {
        this.isLoading = false;
        this.$emit("changeStep", 5, true);
      }
      if (this.type_isolant === "reflechesson_et_non_reflichessant" && !this.norme2) {
        this.isLoading = false;
        this.isCompleted = false;
        this.$refs.snackbar.showSnackbar(this.$t('NORM') + " 2 est obligatoire");
        return;
      }
      await this.isolation_mursAdd();
      if (this.errorMessage !== "") {
        this.isLoading = false;

        return;
      }
      this.isLoading = false;
      this.$emit("changeStep", 5, true);
    },
    goToPrevStep() {
      if(this.visibleTabsLength<=1){
        this.$emit("changePrev",true);
      }else {
        this.$emit("changePrev",false);
      }
      this.$emit("changeStep", 3);
    },
    initializeContactFields() {
      const devis = this.getdevisMonoFiche?.data?.devis;
      this.contactSurSite = devis?.contact_sur_site || null;
      this.fonctionContact = devis?.fonction_contact || null;
      this.telephoneContact = devis?.telephone_contact || null;
    },
    updateContactSurSite() {
      this.getdevisMonoFiche.data.devis.contact_sur_site = this.contactSurSite || null;
      this.setDevisMonoFiche(this.getdevisMonoFiche);
    },
    updateFonctionContact() {
      this.getdevisMonoFiche.data.devis.fonction_contact = this.fonctionContact || null;
      this.setDevisMonoFiche(this.getdevisMonoFiche);
    },
    formatTelephoneContact(event) {
      if (event && event.number && event.country) {
        this.telephoneContact = {
          phone_number: event.number,
          phone_iso_code: event.country.iso2,
          formated_phone: event.formatted || null,
        };
        this.getdevisMonoFiche.data.devis.telephone_contact = this.telephoneContact;
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      } else if (!event || !event.number) {
        this.telephoneContact = null;
        this.getdevisMonoFiche.data.devis.telephone_contact = null;
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      }
    },
  },
};
</script>
<style scoped>
.custom-placeholder::placeholder {
  font-size: 13px;
}
.form-input {
  font-size: 13px;
  height: 41.1px !important;
}
.borderPointier {
  border: 2px dashed #24316d;
  position: relative;
}
.input-style {
  margin-bottom: 1rem;
  border-radius: 4px;
  border: 1px solid #eaebec;
  padding: 0.5rem 0.75rem;
  background-color: #fff;
}

.background-white {
  display: inline-block;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  position: absolute;
  top: -1rem;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: center;
}
.title {
  color: #24316d;
  position: relative;
  z-index: 2;
  margin: 0;
}

.position {
  background-color: white;
  display: inline-block;
  padding: 0.05rem 2rem;
}
.custom-input {
  box-shadow: none;
}
.small-spinner .spinner-border {
  width: 1rem;
  height: 1rem;
}
</style>
